import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isWebshopApiErrorException } from '~/common/types/webshopApiError';

declare global {
  interface Window {
    __QUERY_CLIENT__?: QueryClient;
  }
}

function handleGlobalQueryError(error: unknown): void {
  if (typeof window === 'undefined') return;
  if (!isWebshopApiErrorException(error)) return;
  if (error.apiError.status === 401) {
    window.location.href = '/infra/auth/login';
  }
}

function createBrowserQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError: handleGlobalQueryError }),
    mutationCache: new MutationCache({ onError: handleGlobalQueryError })
  });
}

export function getQueryClient() {
  if (typeof window === 'undefined') return new QueryClient();
  window.__QUERY_CLIENT__ ??= createBrowserQueryClient();
  return window.__QUERY_CLIENT__;
}
